import React, { useState, useEffect, memo } from 'react';
import { useLocation } from 'react-router-dom';
import { 
    SubMenuItem, 
    MenuLink, 
    ScrollContainer, 
    Layout, 
    Content 
} from './MainMenuBar.style';

import FW from '../../../../../config/word.json';

// メニュー定義
export const homeBar = [
    {
        title: FW.F_W_SYS_HOME,
        path: '/home',
        icon: <img src="/images/icons/home_active.svg" alt="" />,
        clickedIcon: <img src="/images/icons/home.svg" alt="" />,
    },
];

export const logOutBar = [
    {
        title: FW.F_W_SYS_LOGOUT,
        path: '/',
        icon: <img src="/images/icons/log-out-active.svg" alt="" />,
        clickedIcon: <img src="/images/icons/log-out.svg" alt="" />,
    },
];

export const approvalGroupBar = [
    { title: FW.F_W_HOME_ApprovalList, 
      path: '/approvallist',
      icon: <span role="img" aria-label="承認待ち" style={{ fontSize: '20px' }}>⏳</span>,
      clickedIcon: <span role="img" aria-label="承認待ち" style={{ fontSize: '20px' }}>⏳</span>
     },
    { title: FW.F_W_HOME_ApprovaledList, 
      path: '/approvaledlist', 
      icon: <span role="img" aria-label="承認済み" style={{ fontSize: '20px' }}>✅</span>,
      clickedIcon: <span role="img" aria-label="承認済み" style={{ fontSize: '20px' }}>✅</span> 
    },
    { title: FW.F_W_HOME_RejectList, 
      path: '/rejectedlist',
      icon: <span role="img" aria-label="否認" style={{ fontSize: '20px' }}>❌</span>,
      clickedIcon: <span role="img" aria-label="否認" style={{ fontSize: '20px' }}>❌</span>,
    },

];

export const menuGroupBar = [
    {
        title: FW.F_W_SYS_HOME,
        path: '/home',
        icon: <img src="/images/icons/home_active.svg" alt="" style={{ width: '25px', objectFit: 'contain' }}/>,
        clickedIcon: <img src="/images/icons/home.svg" alt=""  style={{ width: '25px', objectFit: 'contain' }}/>,
    }, 
    {
        title: FW.F_W_SYS_LOGOUT,
        path: '/',
        icon: <img src="/images/icons/log-out-active.svg" alt=""  style={{ width: '25px', objectFit: 'contain' }}/>,
        clickedIcon: <img src="/images/icons/log-out.svg" alt=""  style={{ width: '25px', objectFit: 'contain' }}/>,
    },
];

export const fansGroupBar = [
    {
        title: FW.F_W_HOME_JOIN,
        path: '/joinInfo',
        icon: <img src="/images/icons/user.svg" alt="" style={{ width: '25px', objectFit: 'contain' }}/>,
        clickedIcon: <img src="/images/icons/user_active.svg" alt="" style={{ width: '25px', objectFit: 'contain' }}/>,
    },
    {
        title: FW.F_W_HOME_FAN,
        path: '/fans',
        icon: <img src="/images/icons/fans.svg" alt="" style={{ width: '25px', objectFit: 'contain' }}/>,
        clickedIcon: <img src="/images/icons/fans_active.svg" alt="" style={{ width: '25px', objectFit: 'contain' }}/>,
    },
    {
        title: FW.F_W_HOME_FANCOUNT,
        path: '/countFans',
        icon: <img src="/images/icons/count.svg" alt="" color='#cccccc' style={{ width: '25px', objectFit: 'contain' }}/>,
        clickedIcon: <img src="/images/icons/count_active.svg" alt="" style={{ width: '25px', objectFit: 'contain' }}/>,
    },
];

export const adGroupBar = [
    {
        title: '統計',
        path: '/adDisplayInfo',
        icon: <span role="img" aria-label="統計" style={{ fontSize: '20px' }}>🎯</span>,
        clickedIcon: <span role="img" aria-label="統計" style={{ fontSize: '20px' }}>🎯</span>
    },
];

// 子リンクコンポーネント
const CustomMenuLink = ({ title, to, icon, clickedIcon, activePath, onClick }) => {
    const isActive = activePath === to;
    const url = useLocation().pathname;
    const onClickMenuItem = (toPage) => () => {
        if (toPage === '/') {
            sessionStorage.clear();
        }
    };
    const active = url.includes(to) && to !== '/' ? 'active' : '';

    return (
        <SubMenuItem>
            <MenuLink
                to={to}
                onClick={onClickMenuItem(to)}
                style={{
                    color: isActive ? 'white' : '#cccccc', // フォント色だけ切替
                }}
            >
                <span style={{ display: 'flex', alignItems: 'center', gap: '8px' }} aria-hidden="true">
                    {active ? icon : clickedIcon}
                    <span>{title}</span>
                </span>
            </MenuLink>
        </SubMenuItem>
    );
};

function MenuBar() {
    const location = useLocation();

    // 一つだけ開くメニューのキーをstateで管理
    const [openKey, setOpenKey] = useState(() => {
        const saved = sessionStorage.getItem('openKey');
        return saved || null;
    });

    // クリック中の子メニューのpathをstateで管理（初期値は現在のURLパス）
    const [activePath, setActivePath] = useState(location.pathname);

    // URL変化があればactivePathも更新
    useEffect(() => {
        setActivePath(location.pathname);
    }, [location.pathname]);

    // openKey を sessionStorage に保存
    useEffect(() => {
        if (openKey) {
            sessionStorage.setItem('openKey', openKey);
        } else {
            sessionStorage.removeItem('openKey');
        }
    }, [openKey]);

    // メニューの開閉切替
    const toggleOpen = (key) => {
        setOpenKey(prev => (prev === key ? null : key));
    };

    return (
        <Layout>
            <Content>
                <ScrollContainer>

                    {/* 基本 */}
                    <SubMenuItem>
                        <div
                            onClick={() => toggleOpen('base')}
                            style={{
                                cursor: 'pointer',
                                color: openKey === 'base' ? 'white' : '#cccccc',
                                padding: '8px',
                                borderRadius: '4px',
                                marginBottom: '4px'
                            }}
                        >
                            ≡基本
                        </div>
                        {openKey === 'base' &&
                            menuGroupBar.map((item) => (
                                <CustomMenuLink
                                    key={item.title}
                                    title={item.title}
                                    to={item.path}
                                    icon={item.icon}
                                    clickedIcon={item.clickedIcon}
                                    activePath={activePath}
                                    onClick={() => setActivePath(item.path)}
                                />
                            ))}
                    </SubMenuItem>

                    {/* 承認フロー */}
                    <SubMenuItem>
                        <div
                            onClick={() => toggleOpen('approval')}
                            style={{
                                cursor: 'pointer',
                                color: openKey === 'approval' ? 'white' : '#cccccc',
                                padding: '8px',
                                borderRadius: '4px',
                                marginBottom: '4px'
                            }}
                        >
                            ✅承認フロー
                        </div>
                        {openKey === 'approval' &&
                            approvalGroupBar.map((item) => (
                                <CustomMenuLink
                                    key={item.title}
                                    title={item.title}
                                    to={item.path}
                                    icon={item.icon}
                                    clickedIcon={item.clickedIcon}
                                    activePath={activePath}
                                    onClick={() => setActivePath(item.path)}
                                />
                            ))}
                    </SubMenuItem>

                    {/* ファン */}
                    <SubMenuItem>
                        <div
                            onClick={() => toggleOpen('fans')}
                            style={{
                                cursor: 'pointer',
                                color: openKey === 'fans' ? 'white' : '#cccccc',
                                padding: '8px',
                                borderRadius: '4px',
                                marginBottom: '4px'
                            }}
                        >
                            ❤️ファン
                        </div>
                        {openKey === 'fans' &&
                            fansGroupBar.map((item) => (
                                <CustomMenuLink
                                    key={item.title}
                                    title={item.title}
                                    to={item.path}
                                    icon={item.icon}
                                    clickedIcon={item.clickedIcon}
                                    activePath={activePath}
                                    onClick={() => setActivePath(item.path)}
                                />
                            ))}
                    </SubMenuItem>

                    {/* 広告 */}
                    <SubMenuItem>
                        <div
                            onClick={() => toggleOpen('ad')}
                            style={{
                                cursor: 'pointer',
                                color: openKey === 'ad' ? 'white' : '#cccccc',
                                padding: '8px',
                                borderRadius: '4px',
                                marginBottom: '4px'
                            }}
                        >
                            📢広告
                        </div>
                        {openKey === 'ad' &&
                            adGroupBar.map((item) => (
                                <CustomMenuLink
                                    key={item.title}
                                    title={item.title}
                                    to={item.path}
                                    icon={item.icon}
                                    clickedIcon={item.clickedIcon}
                                    activePath={activePath}
                                    onClick={() => setActivePath(item.path)}
                                />
                            ))}
                    </SubMenuItem>

                </ScrollContainer>
            </Content>
        </Layout>
    );
}

export default memo(MenuBar);
